import request from '../../utils/request'
import config from '../../config/config'

// 新增菜谱
export function addMenu(data) {
  return request({
    url: config.baseURL + '/api/menus/add',
    method: 'post',
    data
  })
}

// 获取菜谱列表
export function getMenuList(data) {
  return request({
    url: config.baseURL + '/api/menus/list',
    method: 'post',
    data
  })
}

// 修改菜谱
export function updateMenu(data) {
  return request({
    url: config.baseURL + '/api/menus/update',
    method: 'post',
    data
  })
}

// 删除菜谱
export function deleteMenu(data) {
  return request({
    url: config.baseURL + '/api/menus/delete',
    method: 'post',
    data
  })
}
// ding 获取订单列表
export function orderList(data) {
  return request({
    url: config.baseURL + '/api/mealOrders/orderList',
    method: 'post',
    data
  })
}

// 获取菜谱详情
export function getMenuDetail(data) {
  return request({
    url: config.baseURL + '/api/menus/detail',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/menu/index.js